/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UserIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function UserIcon({
  children,
  viewPath = "/DesignSystem/Svgs/UserIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="UserIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-ZeAG3F': alignSelf,'--mt-2-ZeAG3F': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZeAG3F': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZeAG3F': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZeAG3F': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZeAG3F': opacity,'--w-7-ZeAG3F': typeof width === 'number' ? `${width}px` : width,'--h-8-ZeAG3F': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<circle
  data-testid="UserIcon.SvgCircle"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 cx={16}
 cy={12.9}
 r={10.3}
 style={{'--f-9-ZeAG3F': fill,'--s-10-ZeAG3F': stroke}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="UserIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M3.5 29.3c6.9-6.9 18.1-6.9 25.1 0"
 style={{'--f-9-ZeAG3F': fill,'--s-10-ZeAG3F': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}